import Vue from "vue";
import Vuex from "vuex";
import api from "Api";
import router from "Router";
import app from "Main";

import {
	getSubscriptions,
	getSubscription,
	printSubscription,
	createSubscriptions,
	updateSubscriptions,
	deleteSubscriptions,
	getKanban,
	getSubscriptionRenewal,
	createSubscriptionRenewalInvoice,
	voidSubscriptionInvoice,
	getSubscriptionInvoicePdf,
	syncSubscriptionInvoiceToZoho,
} from "Modules/subscriptions/config/api.subscriptions";

const state = {
	device_subscriptions: [],
	page: {},
	form: {},
	subscriptions: [],
	kanban: [],
	kanban_summary: {},
	subscription_options: [],
	selectedSubscription: {
		subscription_id: null,
		account_id: "",
		subscription_date: "",
		reference_number: "",
		status_id: "",
		billing_address_id: "",
		shipping_address_id: "",
		comments: "",
		subscription_details: [],
	},
	subscriptions_filter: {
		search: "",
		status: "active",
		account_id: "",
	},
	device_subscriptions_filter: {
		search: "",
		is_online: "0",
		has_subscription: "1",
	},
	rules_subscriptions: {
		subscription_id: {
			name: "subscription_id",
			rules: "trim|max_length[15]|integer",
			max_len: "15",
			min_len: "",
			default_value: "",
		},
		bill_to_id: {
			name: "bill_to",
			rules: "trim|max_length[15]|integer|required",
			max_len: "15",
			min_len: "",
			default_value: "",
		},
		device_id: {
			name: "device_id",
			rules: "trim|max_length[15]|integer",
			max_len: "15",
			min_len: "",
			default_value: "",
		},
		stripe_subscription_id: {
			name: "stripe_subscription_id",
			rules: "trim|max_length[65]",
			max_len: "65",
			min_len: "",
			default_value: "",
		},
		plan_name: {
			name: "plan_name",
			rules: "trim|max_length[65]",
			max_len: "65",
			min_len: "",
			default_value: "",
		},
		amount: {
			name: "amount",
			rules: "trim|max_length[11]|decimal|required",
			max_len: "10",
			min_len: "",
			default_value: "0.00",
		},
		device_seats: {
			name: "device_seats",
			rules: "trim|max_length[5]|integer",
			max_len: "5",
			min_len: "",
			default_value: "",
		},
		period_start: {
			name: "period_start",
			rules: "trim",
			max_len: "",
			min_len: "",
			default_value: "",
		},
		term_length: {
			name: "term_length",
			rules: "trim|max_length[4]|integer|required",
			max_len: "4",
			min_len: "",
			default_value: "",
		},
		period_end: {
			name: "period_end",
			rules: "trim",
			max_len: "",
			min_len: "",
			default_value: "",
		},
		paid: {
			name: "paid",
			rules: "trim|max_length[1]|integer",
			max_len: "1",
			min_len: "",
			default_value: "",
		},
		billed: {
			name: "paid",
			rules: "trim|max_length[1]|integer",
			max_len: "1",
			min_len: "",
			default_value: "",
		},
		status: {
			name: "status",
			rules: "trim|max_length[20]",
			max_len: "20",
			min_len: "",
			default_value: "",
		},
		invoice_id: {
			name: "invoice_id",
			rules: "trim|max_length[36]",
			max_len: "36",
			min_len: "",
			default_value: "",
		},
		notes: {
			name: "notes",
			rules: "trim",
			max_len: "16777215",
			min_len: "",
			default_value: "",
		},
		is_verified: {
			name: "is_verified",
			rules: "trim|max_length[1]|integer",
			max_len: "1",
			min_len: "",
			default_value: "",
		},
		company_id: {
			name: "company_id",
			rules: "trim|max_length[15]|integer|required",
			max_len: "15",
		},
		plan_id: {
			name: "plan_id",
			rules: "trim|max_length[15]|integer|required",
			max_len: "15",
		},
	},
	selected_subscription_renewal: {},
	selected_subscription_renewal_items: [],
	selected_subscription_renewal_summary: {},
	subscription_renewal_confirm_result: null,
	selected_subscription_renewal_items_grouped: {
		pending: [],
		invoiced: [],
		remaining: [],
		canceled: [],
	},
	selected_subscription_renewal_invoices: [],
};

const getters = {
	subscriptions: (state) => {
		return state.subscriptions;
	},
};

const actions = {
	async fetchSubscriptions({ rootState, commit, dispatch }, payload = null) {
		try {
			let body = payload.body ? payload.body : "";
			let config = {
				headers: payload.headers ? payload.headers : {},
				device_subscriptions: payload.device_subscriptions ? payload.device_subscriptions : false,
			};

			const response = await getSubscriptions({ body: body, headers: config.headers, device_subscriptions: config.device_subscriptions });

			if (typeof response !== "undefined" && response.data) {
				if (response.data.page) {
					commit("mutate", {
						property: "page",
						with: response.data.page,
					});
				}

				if (body.options) {
					commit("mutate", {
						property: "subscription_options",
						with: response.data.subscriptions,
					});
				} else if (response.data.subscriptions) {
					commit("mutate", {
						property: "subscriptions",
						with: response.data.subscriptions,
					});
				} else if (response.data.devices) {
					commit("mutate", {
						property: "device_subscriptions",
						with: response.data.devices,
					});
				}

				return response.data;
			} else {
				console.log("fetch all response error");
				return;
			}
		} catch (error) {
			console.log("fetch all error");
			return;
		}
	},
	async fetchSubscription({ rootState, commit, dispatch }, payload = null) {
		try {
			let response = null;
			let body = payload.body ? payload.body : "";
			let config = {
				headers: payload.headers ? payload.headers : {},
			};

			response = await getSubscription(payload.subscription_id);

			if (typeof response !== "undefined" && response.data) {
				commit("mutate", {
					property: "selectedSubscription",
					with: response.data.subscription,
				});
				return response.data;
			} else {
				console.log("fetch response error");
				return;
			}
		} catch (error) {
			console.log("fetch single error");
			return;
		}
	},
	async printSubscription({ rootState, commit, dispatch }, payload = null) {
		try {
			let response = null;
			let config = {
				headers: payload.headers ? payload.headers : {},
			};

			response = await printSubscription(payload.subscription_id);

			if (typeof response !== "undefined" && response.data) {
				return response.data;
			} else {
				console.log("fetch print response error");
				return;
			}
		} catch (error) {
			console.log("print error");
			return;
		}
	},
	async saveSubscription({ rootState, commit, dispatch }, payload) {
		try {
			let response = null;
			let body = payload.body;
			let config = {
				headers: payload.headers ? payload.headers : {},
			};

			if (typeof body["subscription_id"] === "undefined" || body["subscription_id"] == null || body["subscription_id"] == "") {
				delete body["subscription_id"];
				response = await createSubscriptions({ body: body, headers: config.headers });
			} else {
				let id = body["subscription_id"];
				delete body["subscription_id"];
				response = await updateSubscriptions({ body: body, headers: config.headers }, id);
			}

			if (typeof response !== "undefined" && response.data) {
				return response.data;
			} else {
				console.log("save response error");
				return;
			}
		} catch (error) {
			console.log("save error");
			return;
		}
	},
	async deleteSubscription({ rootState, commit, dispatch }, payload) {
		try {
			let response = null;
			let body = payload.body;
			let config = {
				headers: payload.headers ? payload.headers : {},
			};

			response = await deleteSubscriptions(payload.subscription_id);

			if (typeof response !== "undefined" && response.data) {
				return response.data;
			} else {
				console.log("delete response error");
				return;
			}
		} catch (error) {
			console.log("delete error");
			return;
		}
	},
	async fetchKanban({ rootState, commit, dispatch }, payload = null) {
		try {
			let body = payload.body ? payload.body : "";
			let config = {
				headers: payload.headers ? payload.headers : {},
			};

			const response = await getKanban({ body: body, headers: config.headers, kanban: true });

			if (typeof response !== "undefined" && response.data) {
				if (response.data.page) {
					commit("mutate", {
						property: "page",
						with: response.data.page,
					});
				}

				if (body.options) {
					commit("mutate", {
						property: "kanban",
						with: response.data.kanban,
					});
				} else if (response.data.kanban) {
					commit("mutate", {
						property: "kanban",
						with: response.data.kanban,
					});
				} else if (response.data.devices) {
					commit("mutate", {
						property: "kanban",
						with: response.data.kanban,
					});
				}

				if (response.data.summary) {
					commit("mutate", {
						property: "kanban_summary",
						with: response.data.summary,
					});
				} else {
					commit("mutate", {
						property: "kanban_summary",
						with: {},
					});
				}

				return response.data;
			} else {
				console.log("fetch all response error");
				return;
			}
		} catch (error) {
			console.log("fetch all error");
			return;
		}
	},
	async fetchSubscriptionRenewal({ rootState, commit, dispatch }, payload = null) {
		try {
			let response = null;
			let body = payload.body ? payload.body : "";
			let config = {
				headers: payload.headers ? payload.headers : {},
			};

			response = await getSubscriptionRenewal(payload.renewal_period_id);

			if (typeof response !== "undefined" && response.data) {
				commit("mutate", {
					property: "selected_subscription_renewal",
					with: response.data.renewal_period,
				});
				commit("mutate", {
					property: "selected_subscription_renewal_items_grouped",
					with: Object.assign({ pending: [], invoiced: [], remaining: [], canceled: [] }, response.data.items || {}),
				});

				commit("mutate", {
					property: "selected_subscription_renewal_invoices",
					with: response.data.invoices || [],
				});

				commit("mutate", {
					property: "selected_subscription_renewal_summary",
					with: response.data.summary,
				});
				return response.data;
			} else {
				console.log("fetch response error");
				return;
			}
		} catch (error) {
			console.log("fetch single error");
			return;
		}
	},
	async createSubscriptionRenewalInvoice({ state, commit }, payload) {
		try {
			var renewal_period_id =
				(payload && payload.renewal_period_id) || (state.selected_subscription_renewal && state.selected_subscription_renewal.renewal_period_id);

			if (!renewal_period_id) return;

			var ids = payload && payload.renewal_item_ids ? payload.renewal_item_ids : [];

			var reqBody = { renewal_item_ids: ids };

			var response = await createSubscriptionRenewalInvoice(renewal_period_id, reqBody);

			if (response && response.data) {
				commit("mutate", {
					property: "subscription_renewal_confirm_result",
					with: response.data,
				});
				return response.data;
			}
		} catch (e) {
			console.log("create invoice error");
			return;
		}
	},
	async voidSubscriptionInvoice({ state, dispatch, commit }, payload) {
		try {
			var invoice_id = payload && payload.invoice_id;
			var reason = (payload && payload.reason) || "Customer selected wrong devices";

			if (!invoice_id) return;

			var response = await voidSubscriptionInvoice(invoice_id, { reason });

			if (response && response.data) {
				commit("mutate", {
					property: "subscription_renewal_confirm_result",
					with: response.data,
				});

				// refresh renewal to update invoices + move released items
				var renewal_period_id =
					(payload && payload.renewal_period_id) || (state.selected_subscription_renewal && state.selected_subscription_renewal.renewal_period_id);

				if (renewal_period_id) {
					await dispatch("fetchSubscriptionRenewal", { renewal_period_id: renewal_period_id });
				}

				return response.data;
			}
		} catch (e) {
			console.log("void invoice error");
			return;
		}
	},
	async fetchSubscriptionInvoicePdf({ commit }, payload) {
		try {
			var invoice_id = payload && payload.invoice_id;
			if (!invoice_id) return;

			var response = await getSubscriptionInvoicePdf(invoice_id);

			if (response && response.data && response.data.pdf_url) {
				return response.data;
			}
		} catch (e) {
			console.log("fetch invoice pdf error");
			return;
		}
	},
	async syncSubscriptionInvoiceToZoho({ state, dispatch, commit }, payload) {
		try {
			var invoice_id = payload && payload.invoice_id;
			var force = payload && payload.force ? payload.force : 0;

			if (!invoice_id) return;

			var response = await syncSubscriptionInvoiceToZoho(invoice_id, force);

			if (response && response.data) {
				// Refresh renewal so invoices list updates (sent_to_zoho/ids/last_synced_at)
				var renewal_period_id =
					(payload && payload.renewal_period_id) || (state.selected_subscription_renewal && state.selected_subscription_renewal.renewal_period_id);

				if (renewal_period_id) {
					await dispatch("fetchSubscriptionRenewal", { renewal_period_id: renewal_period_id });
				}

				return response.data;
			}
		} catch (e) {
			console.log("zoho sync error");
			return;
		}
	},
};

const mutations = {
	mutate(state, payload) {
		state[payload.property] = payload.with;
	},
	updateSubscriptionPaid(state, { subscriptionId, paid }) {
		const index = state.subscriptions.findIndex((sub) => sub.id === subscriptionId);
		if (index !== -1) {
			// Replace the subscription with a new object to ensure reactivity
			state.subscriptions.splice(index, 1, {
				...state.subscriptions[index],
				paid: paid,
			});
		}
	},
	updateSubscriptionBilled(state, { subscriptionId, billed }) {
		const index = state.subscriptions.findIndex((sub) => sub.subscription_id === subscriptionId);
		if (index !== -1) {
			// Replace the subscription with a new object to ensure reactivity
			state.subscriptions.splice(index, 1, {
				...state.subscriptions[index],
				billed: billed,
			});
		}
	},
	clearSubscriptions(state) {
		state.page = {};
		state.form = {};
		state.subscriptions = [];
		state.subscription_options = [];
		state.selectedSubscription = {
			subscription_id: null,
			account_id: "",
			subscription_date: "",
			reference_number: "",
			status_id: "",
			billing_address_id: "",
			shipping_address_id: "",
			comments: "",
			subscription_details: [],
		};
	},
	toggleSubscriptionRenewalItem(state, payload) {
		if (!payload || !payload.renewal_item_id) return;

		var grouped = state.selected_subscription_renewal_items_grouped || {};
		var buckets = ["pending", "remaining"];

		for (var b = 0; b < buckets.length; b++) {
			var key = buckets[b];
			var items = (grouped[key] || []).slice();

			for (var i = 0; i < items.length; i++) {
				var it = items[i];
				if (!it) continue;

				if (String(it.renewal_item_id) === String(payload.renewal_item_id)) {
					if (it.selection_locked === "1") return;

					if (key === "remaining") {
						if (it.can_invoice !== true && it.can_invoice !== "1") return;
					}

					var nextVal = it.selected_for_renewal === "1" ? "0" : "1";
					var updated = Object.assign({}, it, { selected_for_renewal: nextVal });

					items.splice(i, 1, updated);

					var newGrouped = Object.assign({}, grouped, {});
					newGrouped[key] = items;

					state.selected_subscription_renewal_items_grouped = newGrouped;
					return;
				}
			}
		}
	},

	mergeSelectedSubscriptionRenewalSummary(state, patch) {
		if (!patch) return;
		var current = state.selected_subscription_renewal_summary || {};
		state.selected_subscription_renewal_summary = Object.assign({}, current, patch);
	},
};

export default {
	state,
	getters,
	actions,
	mutations,
};
